// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Overlay_overlay__3_p4L","overlay__wrapper":"Overlay_overlay__wrapper__oL8gq"};